import React from "react";
import "./Home.css";
import fond_antonio from "./img/fond_antonio.png";
import cv from "./cv.pdf";
import Typed from "typed.js";
import { FaLinkedin, FaGithub, FaYoutube } from "react-icons/fa";

const Home = () => {
  const el = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Développeur Web", "Développeur PHP", "Développeur Symfony"],
      typeSpeed: 80,
      backSpeed: 80,
      backDelay: 900,
      loop: true,
    });

    return () => typed.destroy();
  }, []);

  return (
    <section id="home">

      <div className="hero">

        <div className="text-zone">

          <p className="hello">👋 Salut, je suis</p>

          <h1 className="name">Antonio Navira</h1>

          <h2 className="job">
            Je suis <span ref={el} />
          </h2>

          <p className="subtitle">
            Développeur passionné, je crée des applications performantes avec
            Symfony, PHP et JavaScript 🚀
          </p>

          <div className="socials">
            <a href="https://www.linkedin.com/in/antonio-rollande-yves-andrianavalona-4753a7264/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
            <a href="https://www.youtube.com/@antoniorollandeyves6852" target="_blank" rel="noreferrer"><FaYoutube /></a>
            <a href="https://github.com/antonio150" target="_blank" rel="noreferrer"><FaGithub /></a>
          </div>

          <a href={cv} className="btn-cv" download>
            Télécharger mon CV
          </a>

        </div>

        <div className="photo-zone">
          <img src={fond_antonio} alt="Antonio Navira home" className="photo" />
        </div>

      </div>
    </section>
  );
};

export default Home;
